import BaseEntity from "../base/BaseEntity";
import Filter from "../base/Filter";
import Tank from "../tank/Tank";
import Vue from "vue";

let Status = {
	OK: "OK",
	DISABLED: "DISABLED"
};

let StatusMap = {
	OK: {
		name: "生效",
		value: "OK",
		style: "success"
	},
	DISABLED: {
		name: "未生效",
		value: "DISABLED",
		style: "danger"
	}
};

let Type = {
	FACULTY: "FACULTY",
	GRADUATE: "GRADUATE",
	UNDERGRADUATE: "UNDERGRADUATE",
	ALUMNI: "ALUMNI"
};

let TypeMap = {
	FACULTY: {
		name: "教职工",
		value: "FACULTY",
		style: "warning"
	},
	GRADUATE: {
		name: "研究生",
		value: "GRADUATE",
		style: "info"
	},
	UNDERGRADUATE: {
		name: "本科生",
		value: "UNDERGRADUATE",
		style: "primary"
	},
	ALUMNI: {
		name: "校友",
		value: "ALUMNI",
		style: "success"
	}
};


export default function Person() {

	//extend BaseEntity's Attributes.
	BaseEntity.call(this, arguments);
	//名字
	this.name = null;
	this.image = new Tank("image", false, 1024 * 1024, "图片不超过1M，建议尺寸800*600");
	//头衔
	this.title = null;
	//电话
	this.phone = null;
	//办公地点
	this.office = null;
	this.email = null;
	this.description = null;
	this.status = null;
	this.type = Type.FACULTY;

}


//extend BaseEntity
Person.prototype = new BaseEntity();
Person.prototype.constructor = Person;
Person.prototype.TAG = "person";
Person.prototype.TAGS = "persons";
Person.prototype.URL_PAGE = "/person/page";
Person.prototype.URL_DETAIL = "/person/detail/{id}";
Person.prototype.URL_CREATE = "/person/create";
Person.prototype.URL_EDIT = "/person/edit";
Person.prototype.URL_DEL = "/person/del/{id}";
Person.prototype.URL_STATUS = "/person/status";
Person.prototype.URL_TOP = "/person/top/{id}";


Person.prototype.Status = Status;
Person.prototype.StatusMap = StatusMap;
Person.prototype.StatusList = Person.prototype.getStatusList();
Person.prototype.Type = Type;
Person.prototype.TypeMap = TypeMap;
Person.prototype.TypeList = Person.prototype.getTypeList();

Person.prototype.getFilters = function () {
	return [
		new Filter("SORT", "ID", "orderId"),
		new Filter("SORT", "自定义顺序", "orderSort"),
		new Filter("INPUT", "名称", "name"),
		new Filter("INPUT", "关键字", "keyword"),
		new Filter("MULTI_SELECTION", "类型", "types", Person.prototype.TypeList)
	];
}


//We use this method to get the full js Object.
Person.prototype.render = function (obj) {

	BaseEntity.prototype.render.call(this, obj);

	this.renderEntity("image", Tank);

}

Person.prototype.getForm = function () {

	let form = {
		//名字
		name: this.name,
		imageCode: this.image.code,
		//头衔
		title: this.title,
		//电话
		phone: this.phone,
		//办公地点
		office: this.office,
		email: this.email,
		description: this.description,
		type: this.type
	};
	if (this.id) {
		form.id = this.id;
	}
	return form;
}


Person.prototype.validate = function () {
	//简单验证一下
	if (!this.name) {
		this.errorMessage = "名字必填！";
		return false;
	}
	if (!this.type) {
		this.errorMessage = "请选择类型！";
		return false;
	}
	if (!this.title) {
		this.errorMessage = "头衔必填！";
		return false;
	}
	if (!this.image.exist()) {
		this.errorMessage = "图片必填！";
		return false;
	}

	return true;
}
//置顶某个person.
Person.prototype.httpTop = function (successCallback, errorCallback) {

	let that = this;
	let url = this.URL_TOP.replace("{id}", this.id);
	this.httpPost(url, {}, function (response) {
		that.render(response.data[that.TAG]);
		successCallback && successCallback(response);
	}, errorCallback);

	return true;
}

Person.prototype.detailPageUrl = function () {

	let topic = Vue.store.state.route.meta.topic;
	if (topic) {
		return '/' + topic.location + '/person/detail/' + this.id;
	} else {
		return '/home/person/detail/' + this.id;
	}

}


Person.prototype.click = function () {

	let url = this.detailPageUrl();

	Vue.router.push(url);

}



// WEBPACK FOOTER //
// ./src/common/model/person/Person.js